import React, { useEffect, useRef } from "react";
import stampImage from "../image/BfiStamp.png";
import Logo from "../image/logos.png";
import { Button, Toolbar } from "@mui/material";
import { useParams } from "react-router-dom";
import moment from "moment";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";

/**
 * Pure data-fetching helper (NOT a component).
 * MultipleStickers.jsx calls this for every id so it can build the
 * jsPDF/autoTable version of the sticker without touching the DOM.
 *
 * Returns: { templateId, inputStates }
 */
export const fetchStickerReportData = async (id) => {
  try {
    const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
    const data = res.data[0];

    if (!data || !data.templateValues) {
      console.log("Template data not found or invalid");
      return { templateId: null, inputStates: {} };
    }

    const dataObject = JSON.parse(data.templateValues);
    const inputStates = { ...dataObject };

    return {
      templateId: data?.templateId,
      inputStates,
    };
  } catch (error) {
    console.error("Failed to fetch template: ", error);
    return { templateId: null, inputStates: {} };
  }
};

// Kept exactly as before, exported so the PDF builder can reuse the same
// date-formatting rules the on-screen preview uses.
export function formatDate(value) {
  return moment.utc(value, moment.ISO_8601, true).isValid()
    ? moment.utc(value).format("DD.MM.YYYY")
    : value;
}

export function findDueDate(value, monthsToAdd) {
  const formats = ["DD/MM/YYYY", "DD.MM.YYYY"];
  const parsedDate = moment(value, formats.concat(moment.ISO_8601), true);

  if (parsedDate.isValid()) {
    return parsedDate.add(monthsToAdd, "months").format("DD/MM/YYYY");
  }

  return value;
}

const Sticker = ({ selectedFormID }) => {
  const elementRef = useRef(null);
  const { reportID } = useParams();
  const [newReportID, setNewReportID] = React.useState(
    reportID || selectedFormID
  );
  const [inputStates, setInputStates] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [templateId, setTemplateId] = React.useState(null);

  const handlePrint = () => {
    const printContent = document.getElementById("formToPrint");
    const originalContents = document.body.innerHTML;

    if (printContent) {
      document.body.innerHTML = elementRef.current.innerHTML;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    }
  };
  const fetchformReport = async (id) => {
    setLoading(true);
    try {
      const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
      const data = res.data[0];

      setTemplateId(data?.templateId);

      if (!data || !data.templateValues) {
        console.log("Template data not found or invalid");
        return;
      }

      const dataObject = data.templateValues && JSON.parse(data.templateValues);

      const newDataObject = { ...dataObject };
      // delete newDataObject.reportDate;
      setInputStates(newDataObject);
    } catch (error) {
      console.error("Failed to fetch template: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (newReportID > 0) {
      fetchformReport(newReportID);
    }
  }, [newReportID]);

  return (
    <div
      style={{
        pageBreakInside: "avoid !important",
        width: "100%",
        height: "100%",
        marginTop: "10px",
      }}
    >
      <div
        style={{
          pageBreakInside: "avoid !important",
          marginTop: "20px",
        }}
      >
        <table
          style={{
            height: "100%",
            marginTop: "10px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody id="singlebordertable">
            <tr>
              <td
                style={{
                  width: "100px",
                  padding: "2px",
                  display: "grid",
                  placeItems: "center",
                  height: "100%",
                }}
              >
                <img style={{ height: "80px", width: "80%" }} src={Logo} />{" "}
              </td>
              <td
                colSpan={4}
                style={{
                  textAlign: "center",
                  padding: "2px",
                  borderBottom: "none",
                }}
              >
                <div>
                  <b
                    style={{
                      fontSize: "1rem",
                    }}
                  >
                    Creative Services
                  </b>
                  <br />
                  <h6
                    style={{
                      fontSize: "11px",
                    }}
                  >
                    Kalyan: 113, Blossom Commercial Bldg., Raheja
                    Complex,Kalyan( West ), Dist. Thane. Maharashtra 421301
                    8652233801/ 03 & 9821189331
                  </h6>
                  <hr style={{ margin: "3px 0px" }} />
                  <h6
                    style={{
                      fontSize: "11px",
                    }}
                  >
                    Nashik: 02, Shri Sai Apartment, Pakhal Road, Dwarka, Nashik
                    422011 8652233800/02/05
                  </h6>
                </div>
              </td>
            </tr>

            <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Description
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "9.5px",
                  padding: "2px",
                }}
                colSpan={2}
              >
                {inputStates["distinctiveNumber"] || inputStates["typeIdentificationNumber"]}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Type of Testing
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Test Date
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Due Date
              </td>
            </tr>
          

            {templateId == 12 ? (
              <>    <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                Ultrasonic Test
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["utrasonicTestDate"]}
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["utrasonicExaminationDueDate"]}
              </td>
            </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    Internal Test
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    {inputStates["internalTestDate"]}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    {inputStates["internalExaminationDueDate"]}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    Hydraulic Test
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    {inputStates["hydraulicTestDate"]}
                  </td>
                  <td
                    style={{
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "10px",
                      padding: "2px",
                    }}
                  >
                    {inputStates["hydraulicExaminationDueDate"]}
                  </td>
                </tr>
            
              </>
            ) : (
               <>
              <tr>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["reportDate"] ? moment(inputStates["reportDate"]).format("DD.MM.YYYY") : ""}
              </td>
              <td
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "10px",
                  padding: "2px",
                }}
              >
                {inputStates["certificateValidity"] ? moment(inputStates["certificateValidity"]).format("DD.MM.YYYY") : ""}
              </td>
            </tr>          
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Sticker;
